import ScheduleIcon from '@mui/icons-material/Schedule'
import { ReactElement } from 'react'
import { DateTimeInput } from 'react-admin'
import CreateDialog from '../CreateDialog'
import { addMinutes, isBefore, startOfHour } from 'date-fns'


interface Props {
  certificateId: string
  renderAs?: (open: () => void) => ReactElement
}

const ScheduleDialogButton = ({ certificateId, renderAs }: Props) => {
  const validateFutureDate = (value?: Date) => {
    if (!value) return 'ra.validation.required'
    const now = new Date()
    if (isBefore(value, now)) {
      return 'resources.schedule.actions.dateMustBeInFuture'
    }
    return undefined
  }

  const roundToNextHour = (value: string | Date) => {
    if (!value) return value
    const date = typeof value === 'string' ? new Date(value) : value
    const rounded = startOfHour(addMinutes(date, 59))
    return rounded
  }

  return (
    <CreateDialog
      resource="schedule"
      defaultValues={{ certificateId }}
      dialogTitle="resources.schedule.actions.scheduleInstallationTitle"
      dialogSubtitle="resources.schedule.actions.scheduleInstallationSubtitle"
      dialogIcon={<ScheduleIcon fontSize="small" />}
      renderTrigger={(open) =>
        renderAs
          ? renderAs(open)
          : (
            <button onClick={open} style={{ display: 'none' }} />
          )
      }
    >
      <DateTimeInput
        source="formValues.installationDatum"
        label="resources.schedule.fields.installationDatum"
        validate={[validateFutureDate]}
        fullWidth
        parse={roundToNextHour}
        helperText="resources.schedule.fields.dateFieldHelper"
      />
    </CreateDialog>
  )
}

export default ScheduleDialogButton
